module.exports = __webpack_public_path__ + "img/noimg.08441b70.png";